import React from 'react';
import RoundedIcon from '../../media/components/rounded-icon/RoundedIcon';
import { HdLink } from '../../components';
import { FEATURE_REQUEST_HANDLER } from '../../core/constants/feedback';
import useAnalyticsTracker from '../../analytics/hooks/useAnalyticsTracker';
import { GlobalSearchTracking } from '../constants/global-search-tracking';
import { useGlobalSearchContext } from '../hooks/useGlobalSearchContext';

const UPVOTY_NEW_CONNECTOR_LINK = 'https://hevo.upvoty.com/b/other-feature-requests/';

export function GlobalSearchEmptyResult() {
  const { state: { filters: { search } } } = useGlobalSearchContext();

  const analyticsTracker = useAnalyticsTracker();

  const onSuggestFeatureClick = () => {
    analyticsTracker.eventTrack({
      action: GlobalSearchTracking.TRACKER_GLOBAL_SEARCH_SUGGEST_FEATURE_CLICK,
      properties: {
        handler: FEATURE_REQUEST_HANDLER,
        search
      }
    });
  };

  return (
    <div className='center-flex-col justify-center w-100 h-100' data-id="no-item-box">
      <RoundedIcon iconName='search' containerBg='primary' className='mb-4' />

      <span data-id="no-item-box-title" className='no-item-box-title'>No Results Found 😞</span>

      <span className='no-item-box-desc' data-id='no-item-box-desc'>
        Cannot find what you&apos;re looking for?&nbsp;
        <HdLink
          href={UPVOTY_NEW_CONNECTOR_LINK}
          target='_blank'
          onClick={onSuggestFeatureClick}
          dataId='global-search-feature-request'
        >
          Submit a Feature Request
        </HdLink>
      </span>
    </div>
  );
}
